<template>
    <div class="container">
        <div class="col-xs-12">
            <div class="bordered-title">
                <h3>قد يهمك أيضاً</h3>
            </div>
        </div>
        <div class="col-xs-12">
            <div v-for="product in products" v-if="product.Id != productId" v-bind:key="product.Id"
                 class="col-md-3 col-sm-6 col-xs-12 related-product-item">
                <product :product="product"></product>
            </div>
        </div>
    </div>
</template>
<script>
    import Product from '@/components/products/product';
    import axios from 'axios'

    export default {
        name: 'RelatedProducts',

        data: () => ({
            sectionId: 0,
            products: [],
        }),

        props: ['productId'],

        methods: {
            fetch(sectionId) {
                this.sectionId = sectionId;

                axios.get(apiHost + "/sections/" + this.sectionId + "/products")
                    .then((response) => {
                        this.products = response.data;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            },
        },

        components: {
            Product,
        },
    }
</script>

<style lang="scss">
    @import "src/assets/sass/shared.scss";

    .bordered-title {
        @include text-align($dir);
        border-bottom: 1px solid #ccc;
        margin-bottom: 15px;
        h3 {
            display: inline-block;
        }
    }
    .related-product-item{
        @include float-left($dir);
    }
</style>




// WEBPACK FOOTER //
// src/components/products/related-products.vue